import React from 'react';
import { PassoExecutado } from '@/models/PassoExecutado';
import fhirpath from 'fhirpath';
import { ArtifactFormOverrides } from '@/features/artifacts/components/ArtifactForm/ArtifactForm.types';
import { useArtifactFormConfig } from '@/features/artifacts/hooks/useArtifactFormConfig';
import CardSolicitacao, {
  CardSolicitacaoProxyProps,
} from '../../CardSolicitacao';
import SolicitacaoList from '..';
// import { Container } from './styles';

const Form: ArtifactFormOverrides = [
  { name: 'quantity', label: 'Quantidade' },
  {
    name: 'reasonCode',
    label: 'Indicação clínica',
    attrs: { autoFocus: true },
  },
  { name: 'orderDetail', label: 'Observações' },
];

const CardExame: React.FC<CardSolicitacaoProxyProps> = ({
  solicitacao,
  ...rest
}) => {
  const form = useArtifactFormConfig('solicitacao-exame', Form);

  const title = React.useMemo(() => {
    return (
      fhirpath.evaluate(
        solicitacao.pedido,
        'code.select(text | coding.display).first()',
      )[0] || 'Exame '
    );
  }, [solicitacao.pedido]);

  const description = React.useMemo(() => {
    const note = fhirpath.evaluate(
      solicitacao.pedido,
      'ServiceRequest.note.text',
    );
    if (note.length) {
      return note[0];
    }

    return '';
  }, [solicitacao.pedido]);

  return (
    <CardSolicitacao
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      title={title}
      description={description}
      solicitacao={solicitacao}
      form={form}
    />
  );
};

interface Props {
  passo: PassoExecutado;
}
const SolicitacaoListExame: React.FC<Props> = ({ passo }) => {
  return (
    <SolicitacaoList
      passo={passo}
      tipo="solicitacao-exame"
      CardSolicitacaoComponent={CardExame}
      groupTitle="Selecione os exames que você quer solicitar no seu prontuário."
      addConfig={{
        title: 'Adicionar exame complementar',
      }}
    />
  );
};

export default SolicitacaoListExame;
